import { render } from "./WizardRightSectionHeader.vue?vue&type=template&id=3f47dfc4"
import script from "./WizardRightSectionHeader.vue?vue&type=script&lang=js"
export * from "./WizardRightSectionHeader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./WizardRightSectionHeader.vue?vue&type=style&index=0&id=3f47dfc4&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__